import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import config from '../../js/conf/config'
var CryptoJS = require('crypto-js');
import store from "@/store";
import router from "@/router";
import {refreshTokenApi} from "@/api/main/login";

const SAFE_TOKEN = 'A9jkL8ya';

// Token刷新状态管理
let isRefreshing = false
let refreshSubscribers = []
function timest() {
	var tmp = Date.parse(new Date()).toString();
	tmp = tmp.substr(0, 10);
	return tmp;
}

// 设置验证数据
function setParams(data) {
	var params = {}
	for (let key in data) {
		if (data[key] !== '' && data[key] !== undefined && data[key] !== null && data[key] !== 'undefined') {
			params[key] = data[key]
		}
	}
	// var str_client = 1481029047;
	var str_client = timest();
	str_client = str_client.toString();
	var str_server = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA1(str_client, SAFE_TOKEN));
	params['int_client'] = str_client
	params['str_server'] = str_server
	params['auth'] = localStorage['auth']
	var str_param = ksort(params)
	// str_param ="int_client=1481029047&phone=13873581956&str_server=zLOSzOc5tVlDXL+JjPlIDg+5Qkc="
	// console.log(str_param)
	var str_sign = md5(md5(str_param) + SAFE_TOKEN)
	params['sign'] = str_sign
	return params
}

function ksort(params) { //排序的函数
	let keys = Object.keys(params).sort();
	let newParams = {};
	keys.forEach((key) => {
		newParams[key] = params[key];
	});
	var str_param = '';
	for (let key in newParams) {
		str_param += '&'
		str_param += key
		str_param += '='
		str_param += params[key]
	}
	str_param = str_param.substr(1);
	return str_param;
}

// 订阅token刷新完成
function subscribeTokenRefresh(cb) {
	refreshSubscribers.push(cb)
}

// 通知所有订阅者token已刷新
function onTokenRefreshed(newToken) {
	refreshSubscribers.forEach(cb => cb(newToken))
	refreshSubscribers = []
}

// 刷新token失败，通知所有订阅者
function onRefreshFailed() {
	refreshSubscribers.forEach(cb => cb(null))
	refreshSubscribers = []
}

async function refreshToken() {
	const refreshTokenValue = localStorage[config.refreshTokenKey]
	if (!refreshTokenValue) {
		store.commit('login/OUT_LOGIN')
		router.push('/')
		return null
	}
	
	try {
		// 临时使用refreshToken作为Authorization
		const res = await axios.post(config.baseApi + "/merchant/passport/refresh", {}, {
			headers: { Authorization: `Bearer ${refreshTokenValue}` }
		})
		
		if(res.data.code == 200){
			const expiresAt = Date.now() + (res.data.data.expire_at * 1000)
			store.commit('login/SET_TOKEN', {
				token: res.data.data.access_token,
				re_token: res.data.data.refresh_token,
				token_ex: expiresAt
			})
			return res.data.data.access_token
		} else {
			throw new Error('刷新令牌失败')
		}
	} catch (error) {
		console.error('Token refresh failed:', error)
		store.commit('login/OUT_LOGIN')
		router.push('/')
		return null
	}
}

// 处理401错误，支持并发请求
async function handle401(originalConfig) {
	if (!isRefreshing) {
		isRefreshing = true
		const newToken = await refreshToken()
		isRefreshing = false
		
		if (newToken) {
			onTokenRefreshed(newToken)
			// 重试原请求
			originalConfig.headers.Authorization = `Bearer ${newToken}`
			return axios(originalConfig)
		} else {
			onRefreshFailed()
			return Promise.reject(new Error('Token refresh failed'))
		}
	} else {
		// 正在刷新中，等待刷新完成后重试
		return new Promise((resolve, reject) => {
			subscribeTokenRefresh((newToken) => {
				if (newToken) {
					originalConfig.headers.Authorization = `Bearer ${newToken}`
					resolve(axios(originalConfig))
				} else {
					reject(new Error('Token refresh failed'))
				}
			})
		})
	}
}
// post请求
function _post(url, params = {}, method = 'post') {
	let data = setParams(params)
	let token = localStorage.getItem(config.tokenKey)
	return new Promise((resolve, reject) => {
		axios({
				url: url,
				method: method,
				headers: {
					Authorization : `Bearer ${token}`
				},
				// data: qs.stringify(data)
			data:params
			})
			.then(res => {
				if(res.data.code==401){
					refreshToken()
				}
				resolve(res.data)
			})
			.catch(res => {
				//失败
				reject(res)
			})

	})
}
function httpClient(url, params = {}, method = 'get', customHeaders = {}) {
	let token = localStorage.getItem(config.tokenKey)
	let httpConfig = {
		url: url,
		method: method,
		headers: {
			Authorization : `Bearer ${token}`,
			...customHeaders
		},
	}
	if(method=='get'){
		httpConfig.params= params
	}else{
		httpConfig.data= params
	}
	return new Promise((resolve, reject) => {
		axios(httpConfig)
			.then(async res => {
				if(res.data.code == 401){
					try {
						const retryRes = await handle401(httpConfig)
						retryRes.data.msg = retryRes.data.msg || retryRes.data.message
						resolve(retryRes.data)
					} catch (err) {
						reject(err)
					}
					return
				}
				res.data.msg = res.data.msg || res.data.message
				resolve(res.data)
			})
			.catch(err => {
				reject(err)
			})
	})
}


export default {
	// 	get: _get,
	// 	post: _post
	get: (url, data = {}, customHeaders = {}) => httpClient(url, data, 'get', customHeaders),
	post: (url, data = {}) => httpClient(url, data, 'post'),
	put: (url, data = {}) => httpClient(url, data, 'put'),
	patch: (url, data = {}) => httpClient(url, data, 'patch'),
	delete: (url, data) => httpClient(url, data,'delete'),
	postJson: (url, data = {}, customHeaders = {}) => {
		let token = localStorage.getItem(config.tokenKey)
		let httpConfig = {
			url: url,
			method: 'post',
			headers: {
				'Authorization': `Bearer ${token}`,
				'Content-Type': 'application/json',
				...customHeaders
			},
			data: data,
			maxRedirects: 5
		}
		console.log('postJson sending:', url, data, httpConfig)
		return new Promise((resolve, reject) => {
			axios(httpConfig)
				.then(async res => {
					if(res.data.code == 401){
						try {
							const retryRes = await handle401(httpConfig)
							retryRes.data.msg = retryRes.data.msg || retryRes.data.message
							resolve(retryRes.data)
						} catch (err) {
							reject(err)
						}
						return
					}
					res.data.msg = res.data.msg || res.data.message
					resolve(res.data)
				})
				.catch(err => {
					reject(err)
				})
		})
	}
}
